
import { handleError } from '@/plugins/helper'
import AuroraBackground from '~/components/common/aurora-background.vue'
import PageBottom from '~/components/common/page-bottom/index.vue'
import TextPressure from '~/components/common/text-pressure.vue'
import FooterNew from '~/components/FooterNew.vue'
import TextPressureMixin from '~/mixins/text-pressure.vue'
import RelatedArticles from '~/sections/vision/ai-workspace/related-articles.vue'
import VisionChildKv from '~/sections/vision/child-kv.vue'
import AiProgram from '~/sections/vision/child-program.vue'
import Initiatives from '~/sections/vision/initiatives.vue'

export default {
  components: {
    TextPressure,
    PageBottom,
    FooterNew,
    AuroraBackground,
    Initiatives,
    VisionChildKv,
    RelatedArticles,
    AiProgram
  },
  mixins: [TextPressureMixin],
  layout: 'home',
  async asyncData({ $content }) {
    const articles = await $content('article/all')
      .limit(4)
      .only(['url', 'thumbnail', 'thumbnailUrl', 'category', 'publicDateStr', 'title', 'media'])
      .fetch()
      .catch(handleError)

    return { articles: Array.isArray(articles) ? articles : [articles] }
  },
  data() {
    return {
      articles: [],
      initiatives: [
        {
          icon: '/images/vision/icon-chat.svg',
          title: 'ソースレビュー',
          description:
            'PR-Agentの導入を進めています。特に、エンジニアリングにおけるAIエージェントの導入に注力しており、CognitionAIとパートナー契約を結び、Devin Enterpriseの利用準備を進めています。2025年9月からは限定ユーザーへのα提供を開始するなど、最先端のAIエージェントを活用した開発プロセスの変革を加速させています。'
        },
        {
          icon: '/images/vision/icon-building.svg',
          title: '運用生産性の向上',
          description:
            'ObservabilityとAIOpsを活用した運用自動化、特にレガシー領域（mbga）をターゲットとしています。dynatraceを使ったPoC（Proof of Concept）では、Observability機能により年間3人月強の削減見込みが確認されており、コストメリットの最大化に向けた取り組みが着実に進行しています。さらに、プログラム脆弱性診断AIとDevinによる自動修正のPoCも計画されるなど、AIを活用して開発から運用まで、エンジニアリングの全領域を最適化し続けています。'
        }
      ]
    }
  },
  head() {
    const title = 'Engineering | VISION'
    const extendMeta = this.$helper.setMetaTitleAndDescription(title)

    return {
      title,
      meta: [...extendMeta]
    }
  }
}
